/// <reference types="@types/jquery" />

document.addEventListener('DOMContentLoaded', () => {
	document
		.querySelectorAll<HTMLElement>('.BlogPostSlider_post__VRwNY')
		.forEach(slide => {
			slide.addEventListener('mousemove', e => {
				const slideRect = slide.getBoundingClientRect()
				const { top, left, width, height } = slideRect

				const x = e.clientX - left
				const y = e.clientY - top

				const normalX = (x / width) * 2 - 1
				const normalY = (y / height) * 2 - 1

				slide.style.transform = `rotateX(${normalY}deg) rotateY(${normalX}deg)`
			})
		})

	if ($('.BlogPostSlider_post__VRwNY').length) {
		let listSlides = $('.BlogPostSlider_post__VRwNY')
		let maxHeight = 0

		listSlides.each((_i, e) => {
			if ($(e).height() > maxHeight) {
				maxHeight = $(e).height()
			}
		})

		listSlides.each((_i, e) => {
			$(e).css('height', `${maxHeight + 20}px`)
		})
	}

	if ($('.BlogPostSlider_postSliderContainer___k2Au').length) {
		var arrowRight = false

		const arrowCursor = $('.ArrowCursor_arrowCursor__ppRH9')

		window.addEventListener('mousemove', function (e) {
			e.stopPropagation()

			const x = e.clientX
			const y = e.clientY

			const rect = document
				.querySelector('.BlogPostSlider_postSliderContainer___k2Au')
				?.getBoundingClientRect()

			arrowCursor.css('left', `${x - rect.left}px`)
			arrowCursor.css('top', `${y - rect.top}px`)

			if (x > $(window).width() / 2) {
				arrowCursor.css('transform', 'translate(-0%, -0%) rotate(180deg)')
				arrowRight = true
			} else {
				arrowCursor.css('transform', 'translate(-0%, -0%)')
				arrowRight = false
			}
		})

		//.BlogPostSlider_mantine-Carousel-slide__x6vUu.green a
		const sliderSectionRelative = $(
			'.BlogPostSlider_sliderSectionRelative__nUQ_c'
		)
		sliderSectionRelative.on('mouseenter', () => {
			arrowCursor.css('opacity', `1`)
		})
		sliderSectionRelative.on('mouseleave', () => {
			arrowCursor.css('opacity', `0`)
		})

		$('.BlogPostSlider_mantine-Carousel-slide__x6vUu').on(
			'mouseover',
			function () {
				if ($(this).hasClass('green')) {
					$('.ArrowCursor_arrowCursor__ppRH9 svg path').css('stroke', `#fff`)
				} else {
					$('.ArrowCursor_arrowCursor__ppRH9 svg path').css('stroke', `#011CFF`)
				}
			}
		)
	}

	$('.BlogPostSlider_boldLink__Oq1hw').on('click', function (e) {
		e.stopPropagation()
	})

	$('.BlogPostSlider_boldLink__Oq1hw').on(
		'hover',
		() => {
			$('.ArrowCursor_arrowCursor__ppRH9').fadeOut(0)
		},
		() => {
			$('.ArrowCursor_arrowCursor__ppRH9').fadeIn(0)
		}
	)

	if ($('.mantine-1s8spa111').length) {
		let mainSlider = $('.mantine-1s8spa111').owlCarousel({
			items: 1,
			loop: true,
		})

		window.addEventListener('resize', () => {
			mainSlider.trigger('refresh.owl.carousel')
		})

		$('.BlogPostSlider_postSliderContainer___k2Au').on('click', function (e) {
			if (arrowRight) {
				mainSlider.trigger('next.owl.carousel')
			} else {
				mainSlider.trigger('prev.owl.carousel')
			}
		})

		$(window).on('resize', () => {
			mainSlider.trigger('refresh.owl.carousel')
		})
	}
})
